let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cTyco")).then(() => parcelRequire('j51AU'));